<template>
  <div>
    <div class="button-wrapper">
      <div class="button-item export" :class="{ disabled: tableData.length === 0 }" @click="exportExcel">导出Excel</div>
      <div class="button-item back" @click="goBack">返回</div>
    </div>
    <List v-show="tableData.length > 0" class="questionnaire-detail" :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="8">
      <template v-slot:listContent>
        <div class="questionnaire-detail-content">
          <el-table class="questionnaire-detail-table" :data="tableData" border v-show="questions.length > 0" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
            <el-table-column v-for="(item, index) in questions[0]" :key="index" :label="item.title" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.formData[index].value }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="提交时间" min-width="180"> </el-table-column>
            <el-table-column label="操作" min-width="80">
              <template slot-scope="scope">
                <div class="option-button" @click="deleteOne(scope.row)">删除</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" :appendToBody="true" @clickCancel="deleteCancel" @clickConfirm="deleteConfrim"></TipDialog>
    </List>
  </div>
</template>
<script>
import List from '@components/list/listFrame'
import { getFormData, deleteData } from '@api/questionaire'
import TipDialog from '@components/common/TipDialog.vue'
export default {
  name: 'questionnaireList',
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      tableData: [],
      questions: [],
      deleteId: null,
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '删除后无法恢复，是否确认删除？'
      },
      headerCellStyle: { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' },
      cellStyle: { 'text-align': 'center' }
    }
  },
  props: ['formId', 'sourceIden'],
  methods: {
    //翻页
    flipPage(pageNo) {
      this.getFormData(pageNo)
      this.currentPageNo = pageNo
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    getFormData(pageNo) {
      let params = {
        pageNo: pageNo,
        pageSize: 8,
        formId: this.formId,
        sourceIden: this.sourceIden
      }
      getFormData(params).then((res) => {
        if (res.status === 200 && res.data) {
          let data = res.data.page
          this.totalCount = data.totalCount
          this.tableData = data.result.map((item) => {
            item.formData = JSON.parse(item.formData)
            this.questions.push(item.formData)
            let time = new Date(item.createTime)
            item.createTime = `${time.getFullYear()}-${this.add0(time.getMonth() + 1)}-${this.add0(time.getDate())} ${this.add0(time.getHours())}:${this.add0(time.getMinutes())}:${this.add0(
              time.getSeconds()
            )}`
            return item
          })
        }
      })
    },
    deleteOne(form) {
      this.deleteId = form.id
      this.$refs.deleteDialog.visible = true
    },
    goBack() {
      this.$emit('updateComponent', { toWhere: 'list' })
    },
    deleteCancel() {
      this.$refs.deleteDialog.visible = false
    },
    deleteConfrim() {
      deleteData({ ids: Number(this.deleteId) }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          if (this.tableData.length === 1 && this.currentPageNo > 1) {
            this.currentPageNo--
          }
          this.getFormData(this.currentPageNo)
        } else {
          this.$alert(res.data.msg, '提示', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    exportExcel() {
      if (this.tableData.length > 0) {
        let a = document.createElement('a')
        a.href = `${window.PROJECT_CONFIG.BASE_URL}/ebook/questionnaire/export?formId=${this.formId}`
        a.click()
      }
    }
  },
  mounted() {
    this.getFormData(1)
  },
  components: {
    List,
    TipDialog
  }
}
</script>
<style lang="scss" scoped>
.button-wrapper {
  margin-bottom: 30px;
  .button-item {
    display: inline-block;
    width: 90px;
    height: 30px;
    margin-right: 20px;
    text-align: center;
    line-height: 28px;
    cursor: pointer;
    box-sizing: border-box;
    &.export {
      background-color: #df5813;
      color: #fff;
    }
    &.disabled {
      background-color: #cecece;
      color: #fff;
    }
    &.back {
      border: 1px solid #df5813;
      color: #df5813;
      background-color: #fff;
    }
  }
}
.questionnaire-detail {
  width: 100%;
  /deep/ .common-list {
    padding-top: 0;
    max-height: calc(100vh - 280px);
  }
  .questionnaire-detail-content {
    padding-right: 20px;
    width: 100%;
    max-height: calc(100% - 42px);
    /deep/ .questionnaire-detail-table {
      width: 100%;
      max-height: 100%;
    }
  }
  .option-button {
    cursor: pointer;
    color: #df5813;
  }
}
</style>
